import React from "react";
import { GiGrass, GiSpade, GiLevelEndFlag, GiWaterDrop } from "react-icons/gi";
import "./Turfhome.css";
import { Link } from "react-router-dom";

const Turfhome = () => {
  const features = [
    {
      icon: <GiGrass className="feature-icon" />,
      title: "Premium  Selection",
      text: "Choose from top-grade, climate-matched options for an instant, vibrant lawn.",
    },
    {
      icon: <GiSpade className="feature-icon" />,
      title: "Expert Ground Prep",
      text: "We don't lay the turf or sod on until the area is properly cleared and ready to go.",
    },
    {
      icon: <GiLevelEndFlag className="feature-icon" />,
      title: "Seamless Installation",
      text: "We align and seam each roll flawlessly, without gaps, bumps or tripping hazards.",
    },
    {
      icon: <GiWaterDrop className="feature-icon" />,
      title: "After-Care",
      text: "We give you maintenance tips to keep your lawn greener for longer.",
    },
  ];

  return (
    <section className="turfhome">
      <div className="turfhome__container">
        <div className="turfhome__content">
          <div className="turfhome__intro">
            <span className="turfhome__kicker">Premium Turf & Sod</span>
            <h2 className="turfhome__headline">Instant Green, Zero Hassle</h2>

            <p className="turfhome__description"></p>

            <p className="turfhome__description">
              We install both natural sod and artificial turf, depending on your
              needs.For sod, we handle the soil preparation, leveling, and
              installation in one day. We use quality, climate-appropriate grass
              and make sure seams are tight and even. Irrigation is adjusted to
              support early root growth. We provide care instructions and check
              in after the job to make sure the lawn is taking well. Our work
              includes a warranty.
            </p>

            <p className="turfhome__description">
              For artificial turf, we build a proper base and install turf
              designed to handle wear and weather. It's a good choice for areas
              where you want a green look without regular upkeep. We include
              drainage and edging to keep everything in place.Whether you choose
              sod or turf, we focus on doing the job right.
            </p>

            <p className="turfhome__description"></p>

            <Link to="/contact" className="turfhome__cta">
              Get a Quote
              <span className="cta-arrow">→</span>
            </Link>
          </div>

          <div className="turfhome__features">
            {features.map(({ icon, title, text }, idx) => (
              <div className="feature-card" key={idx}>
                <div className="feature-icon-container">{icon}</div>
                <h3 className="feature-title">{title}</h3>
                <p className="feature-text">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Turfhome;
